import React from "react";
import { FormattedMessage } from 'react-intl';
import 'stylesheets/tab.scss';
import 'stylesheets/layout.scss';
import 'stylesheets/fonts.scss';
import { Mixpanel } from 'helpers/Mixpanel';
import TeamFeed from "./TeamFeed/TeamFeedContainer";
import ChatFeed from "./ChatFeed/ChatFeedContainer";
import Modal from 'components/GeneralComponents/Modal';
import styledConfirm from '../Requests/components/styled';
import CreateChatGroupModal from "./CreateFeed/CreateChatGroupModal";
import uniqBy from 'lodash/uniqBy';
import { getUserId } from '../../helpers/cookies';
import CreateChannelModal from "./CreateFeed/CreateChannelModal";

const TABS = [
  { label: "Channels", component: <TeamFeed /> },
  { label: "Direct Messages", component: <ChatFeed /> },
];

const TABSDisableDm = [
  { label: "Channels", component: <TeamFeed /> },
];

class CommunityTabComponent extends React.Component {
  state = {
    activeTab: 0,
    showNewChatModal: false,
    showCreateChannelModal: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const initialTab = match.params.module === 'teamfeed' ? 0 : 1;

    this.setState({ activeTab: initialTab }, () => {
      this.trackTabView(initialTab);
    });
  }

  trackTabView = (tabIndex) => {
    const label = TABS[tabIndex]?.label;
    if (label) {
      Mixpanel.track(`${label} Page`);
    }
  }

  handleTabClick = (tabIndex) => {
    this.setState({ activeTab: tabIndex }, () => {
      this.trackTabView(tabIndex);
    });
  }

  openNewChatModal = () => {
    this.setState({ showNewChatModal: true, showCreateChannelModal: false });
  };

  closeNewModal = () => {
    this.setState({ showNewChatModal: false, showCreateChannelModal: false });
  };

  onOpenCreateChannel = () => {
    this.setState({ showNewChatModal: false, showCreateChannelModal: true });
  };


  render() {
    const { activeTab, showNewChatModal, showCreateChannelModal } = this.state;
    const { managers, associates, shouldDisableDm, shouldDisableGroupCreate } = this.props;

    const loggedInUserId = parseInt(getUserId());
    const temp = managers.concat(associates);
    const temp1 = temp.filter(user => user && user.status === 'active' && user.owner_id !== loggedInUserId);
    const activeUsers = uniqBy(temp1, 'id');

    const TABSToShow = shouldDisableDm ? TABSDisableDm : TABS;

    return (
      <div className="top-tab_wrap" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 70px)' }}>
        <div className="category__wrap" style={{ maxHeight: '40px', padding: '10px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            {TABSToShow.map((tab, index) => (
              <div
                key={index}
                className={activeTab === index ? 'category__text-wrap-selected' : 'category__text-wrap'}
                onClick={() => this.handleTabClick(index)}
              >
                <p className="category__text">{tab.label}</p>
              </div>
            ))}
          </div>

          {!(
            shouldDisableGroupCreate === 0 && shouldDisableDm === true
          ) && <button className="category__create-button" style={{ height: '32px' }} onClick={this.openNewChatModal}>
              <FormattedMessage id="Category.create" defaultMessage="Create" />
            </button>}
        </div>

        <div className="top-tab_container" style={{ flexGrow: 1, overflowY: 'auto' }}>
          {TABS[activeTab]?.component}
        </div>

        {showNewChatModal && (
          <Modal>
            <CreateChatGroupModal
              allUsers={activeUsers}
              createChatSession={this.props.createChatSession}
              locationId={this.props.locationId}
              currentUserId={loggedInUserId}
              onClose={this.closeNewModal}
              shouldDisableDm={shouldDisableDm}
              shouldDisableGroupCreate={shouldDisableGroupCreate}
              onOpenCreateChannel={this.onOpenCreateChannel}
              onChatCreate={() => this.handleTabClick(1)}
            />
          </Modal>
        )}

        {showCreateChannelModal && (
          <Modal>
            <CreateChannelModal
              locationId={this.props.locationId}
              currentUserId={loggedInUserId}
              onClose={this.closeNewModal}
              onChannelCreate={() => this.handleTabClick(0)}
              createChannel={this.props.createChannel} // if you're passing a prop to handle API call
            />
          </Modal>
        )}
        <styledConfirm.Overlay display={showNewChatModal ? 'block' : 'none'} />
      </div>
    );
  }

}

export default CommunityTabComponent;
